import type { Wrex } from '@lumapps/wrex/types';

import { COLUMNS } from '../constants';
import type { ColumnsElement } from '../types';
import { createColumn } from './createColumn';

/** Create a columns element */
export const createColumns = (
    attributes: Wrex.ElementAttributes<ColumnsElement>,
    children: ColumnsElement['children'] = [createColumn(), createColumn()],
): ColumnsElement => {
    return { type: COLUMNS, ...attributes, children };
};
